import { Host, Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import InfoTipModel from './info-tip.model';
import { I18NService } from 'portal-i18n-lib';

@Injectable(
	{
		providedIn: 'root'
		// , deps: [ I18NService ]
	}
)
export class InfoTipService {
	private readonly i18n$: Observable<Array<InfoTipModel>>;

	constructor(
		// @Host() @Inject(I18NService) private readonly i18nService: I18NService
		private i18nService: I18NService
	) {
		this.i18n$ = this.i18nService
			.model$
			.pipe(catchError(err => {
				console.error(err);

				return of([]);
			}))
			.pipe(shareReplay(1));
	}

	public getInfo$(label: string): Observable<InfoTipModel> {
		return this.i18n$
			// .pipe(tap(_ => console.log("getInfo$", label, _)))
			.pipe(map(t => t.find(model => model.codiceLabel == label)));
	}
}
